import { fg } from '@atlassian/jira-feature-gating';

const JsmAnivRouteRedirectionRelayProvider = {
	get(): boolean {
		return fg('jsm_aniv_route_redirection');
	},
};

export default JsmAnivRouteRedirectionRelayProvider;
